import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

const autoWidth = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)`
		width: auto;
	`;

export default autoWidth;
